var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      attrs: {
        type: _vm.type,
        name: _vm.name,
        disabled: _vm.disabled,
        readonly: _vm.readonly,
        required: _vm.required,
      },
      domProps: { value: _vm.content },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event.target.value || "")
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Components/Common/FormInput.vue